import { useRandomUserGenerator } from '../../test-data/hooks/useRandomUserGenerator';
import { useAliases } from '../../aliases/hooks/useAliases';

export const useGenerateTestMessage = () => {
    const { generateRandomUser } = useRandomUserGenerator();
    const { items: aliases } = useAliases();

    const subjects = [
        'Quick question about the project',
        'Meeting follow-up',
        'Important update',
        'Review request',
        'Collaboration opportunity'
    ];

    const messages = [
        '<p>Hi there,</p><p>I wanted to reach out regarding our recent discussion. Let me know your thoughts.</p><p>Best regards</p>',
        '<p>Hello,</p><p>Just following up on our previous conversation. Looking forward to your feedback.</p><p>Thanks</p>',
        '<p>Hi,</p><p>I hope this message finds you well. I wanted to share some updates with you.</p><p>Cheers</p>',
        '<p>Hey,</p><p>Quick update on the project status. Please review when you get a chance.</p><p>Regards</p>',
        '<p>Hello,</p><p>I have some ideas I\'d like to discuss with you. Let me know if you\'re available.</p><p>Best</p>'
    ];

    const generateTestMessage = (setFieldValue: (field: string, value: any) => void, currentAliasId: string) => {
        const user1 = generateRandomUser();
        const user2 = generateRandomUser();
        
        if (!currentAliasId && aliases.length > 0) {
            setFieldValue('aliasId', aliases[0].id);
        }
        setFieldValue('to', `${user1.email}, ${user2.email}`);
        setFieldValue('subject', subjects[Math.floor(Math.random() * subjects.length)]);
        setFieldValue('htmlBody', messages[Math.floor(Math.random() * messages.length)]);
        setFieldValue('useHtml', true);
    };

    return { generateTestMessage };
};
